import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BreadcrumbsComponent } from '@global/breadcrumbs.component';
import { DebounceDirective } from '@helpers/debounce.directive';
import { FormatSizePipe } from '@helpers/format-size.pipe';
import { GroupeUtilisateurPipe } from '@app/groupe-utilisateur';
import { GZInputNumberFormatterDirective } from '@helpers/gz-input-number-formatter.directive';
import { InjectHTMLDirective } from '@helpers/inject-html.directive';
import { MimeTypePipe } from '@helpers/mime-type.pipe';
import { NullIfEmptyDirective } from '@helpers/null-if-empty.directive';
import { SafeHtmlPipe } from '@helpers/safe-html.pipe';
import { TreeLevelWedgeComponent } from '@helpers/tree-level-wedge';
import { TypeMediaPipe } from '@app/media/type-media.pipe';
import { VarDirective } from '@helpers/ng-var.directive';

import { UIRouterModule } from '@uirouter/angular';

@NgModule({
	declarations: [
		BreadcrumbsComponent,
		DebounceDirective,
		FormatSizePipe,
		GroupeUtilisateurPipe,
		GZInputNumberFormatterDirective,
		InjectHTMLDirective,
		MimeTypePipe,
		NullIfEmptyDirective,
		SafeHtmlPipe,
		TreeLevelWedgeComponent,
		TypeMediaPipe,
		VarDirective,
	],
	imports: [
		CommonModule,
		UIRouterModule,
	],
	exports: [
		BreadcrumbsComponent,
		CommonModule,
		DebounceDirective,
		FormatSizePipe,
		GroupeUtilisateurPipe,
		GZInputNumberFormatterDirective,
		InjectHTMLDirective,
		MimeTypePipe,
		NullIfEmptyDirective,
		SafeHtmlPipe,
		TreeLevelWedgeComponent,
		TypeMediaPipe,
		UIRouterModule,
		VarDirective,
	]
})
export class GlobalModule { }
